import { Component, EventEmitter, Input, OnInit, OnChanges, Output } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { MessageService } from 'primeng/api';
import { ApiService, createFailureToDeleteMsg  } from 'src/app/services/api.service';
import { ConfigModel } from 'src/app/models/config.model';
import { UserModel } from 'src/app/models/user.model';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { DeviceModel } from 'src/app/models/device.model';

@Component({
  selector: 'app-delete-config',
  templateUrl: './delete-config.component.html',
  styleUrls: ['./delete-config.component.scss']
})
export class ConfigDeleteComponent implements OnInit, OnChanges {
  @BlockUI() blockUI: NgBlockUI | undefined;
  @Input() visible = false;
  @Input() configs: any[] = [];
  @Output() onClose: EventEmitter<any> = new EventEmitter();
  @Output() visibleChange: EventEmitter<any> = new EventEmitter();

  isLoading = false;
  isVam: boolean = false;
  isReviewer: boolean = false;
  isOps: boolean = false;

  currentUser?: UserModel;

  canDelete = true;
  attachedDevicesByProfile: {
    profileName: string;
    profileOrg: string;
    devices: DeviceModel[]
  }[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private api: ApiService,
    private location: Location,
    private messageService: MessageService
  ) {
    const userStr = localStorage.getItem('currentUser');
    if (userStr) {
      this.currentUser = JSON.parse(userStr);
      this.isVam = this.currentUser?.organization.type === 'VAM';
      this.isReviewer = this.currentUser?.role === 'Reviewer';
      this.isOps = this.currentUser?.role === 'Ops';
    }
  }

  ngOnInit(): void {
  }

  async ngOnChanges() {
    if (this.visible) {
      await this.checkAttachedDevices();
    }
  }

  private async checkAttachedDevices(): Promise<void> {
    try {
      this.isLoading = true;
      this.attachedDevicesByProfile = [];

      for (const config of this.configs) {
        if (!config.groupId) {
          continue;
        }

        const devices = await this.api.get<DeviceModel[]>(
          `/devices/config/group/${config.groupId}`
        );

        if (devices?.length) {
          this.attachedDevicesByProfile.push({
            profileName: config.name,
            profileOrg: config.org?.name,
            devices
          });
        }
      }

      this.canDelete = this.attachedDevicesByProfile.length === 0;
    } finally {
      this.isLoading = false;
    }
  }

  async delete() {
    if (!this.canDelete) {
      return;
    }

    try {
      this.blockUI?.start();

      const payload = this.configs.map(config => config.id);

      console.log(`delete payload is ${payload}`);

      const response = await this.api.request('DELETE', `/configs`, {
        body: { ids: payload }
      });

      console.log(`${JSON.stringify(response)}`);

      this.onClose.emit();
      this.visible = false;
      this.visibleChange.emit(false);
    } catch (err: any) {
      console.log(`${JSON.stringify(err)}`);
      const errors = createFailureToDeleteMsg(err, this.configs, 'profile');
      this.messageService.addAll(errors);
    } finally {
      this.blockUI?.stop();
    }
  }

  closeDialog(): void {
    this.attachedDevicesByProfile = [];
    this.canDelete = true;
    this.isLoading = false;
    this.visible = false;
    this.visibleChange.emit(false);
  }

  onCloseDialog(): void {
    this.attachedDevicesByProfile = [];
    this.canDelete = true;
    this.isLoading = false;
  }
}
